/**
 * Adds 'px' to the number and turns it into a string
 */
export const toPx = num => `${num}px`;

/**
 * Converts val to ${num}px if the input is typeof === 'number'. Otherwise, it is passed as is.
 *
 * @param val number | string
 * @returns string
 */
export const pxNormalizer = val => typeof val === 'number' ? `${val}px` : val;